import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addCommas,
    addFromColumn,
    sortCurrency,
    sortNumber,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/receipt';

/**
 * Class for displaying Location Sales in a table
 *
 */
class DiscountsListTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Discount ID', key: 'discount_id'},
                {label: 'Discount Name', key: 'discount_name'},
                {label: 'Total Amount Saved by Discount', key: 'total_amount_saved'},
                {label: 'Avg Amount Saved by Discount', key: 'avg_amount_saved'},
                {label: 'Max Amount Saved by Discount', key: 'max_amount_saved'},
                {label: 'Discount Qty Redeemed', key: 'discount_qty_redeemed'},
                {label: 'Sum of Product Subtotal where Discount was Applied', key: 'discount_product_subtotal'},
                {label: 'Sum of Product Tax where Discount was Applied', key: 'discount_product_tax'},
                {label: 'Sum of Product Total where Discount was Applied', key: 'discount_product_total'},
                {label: 'Product Qty Total where Discount was Applied', key: 'discount_product_qty'}
            ],
        };
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Update selected table data based on filter
     *
     * @param event
     * @param table
     */
    handleFilterChange = (event, table) => {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    };

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {

        const {
            endDate,
            startDate,
            system,
            tableFilename,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('discount_id');

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Discount ID',
                        accessor: 'discount_id',
                        sortMethod: (a, b) => sortNumber(a, b, 'ASC'),
                        style: tableStyles.right,
                    },
                    {
                        Header: 'Discount Name',
                        accessor: 'discount_name'
                    }
                ]
            },
            {
                Header: 'Amount Saved by Discount',
                columns: [
                    {
                        Header: 'Total $',
                        accessor: 'total_amount_saved',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_amount_saved'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Avg $',
                        accessor: 'avg_amount_saved',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'avg_amount_saved'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Max $',
                        accessor: 'max_amount_saved',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'max_amount_saved'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Qty <br/>Redeemed</span>),
                        accessor: 'discount_qty_redeemed',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'discount_qty_redeemed'))}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: 'Currency Spent Using Discounts',
                columns: [
                    {
                        Header: 'Subtotal',
                        accessor: 'discount_product_subtotal',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'discount_product_subtotal'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Tax',
                        accessor: 'discount_product_tax',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'discount_product_tax'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Total',
                        accessor: 'discount_product_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'discount_product_total'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Qty',
                        accessor: 'discount_product_qty',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'discount_product_qty'))}
                            </span>
                        )
                    }
                ]
            }

        ];

        return (
            <div>
                <div className="reports-table-container">

                    {/* Table Header */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Button */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={`${tableFilename}-${system}-${dateString}.csv`}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export {tableLabel}
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Tables: Display and Print */}
                    <ReactTable
                        key={`table-${tableFilename}-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.locationsReacttable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.locationsReacttable)}
                        ref={(r) => this.locationsReacttable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-${tableFilename}-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
            </div>
        )
    }
}

DiscountsListTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    allowLocationSelection: PropTypes.bool,
    listData: PropTypes.array,
    locationIconFunction: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableFilename: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

DiscountsListTable.defaultProps = {
    addField: true,
    endDate: null,
    allowLocationSelection: true,
    startDate: null,
    tableFilename: 'Discounts',
    tableKey: 'Discounts',
    tableLabel: 'Discounts'
};

export default DiscountsListTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountsListTable.js